export default __webpack_public_path__ + "static/media/lead-call.dc0301ba.svg";